<template>
  <div
    @click="onClick"
  >
    <ui-badge
      :text="COUNT"
      max-width="50"
      use-animate-badge
    />
    <f-sprite-icon
      :icon-link="$options.icons.IconHeart"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import IconHeart from '@icons/heart.svg';

export default {
  name: 'control-favorites',

  icons: {
    IconHeart,
  },

  computed: {
    ...mapGetters({
      COUNT: 'favorites/favoritesShortCount',

    }),
  },

  methods: {
    onClick() {
      this.$auth.login().then(() => {
        location.assign('/account/favorites');
      }).catch(() => {});
    },
  },
};
</script>
